// Provider identity shown in front of the workspace title (replaces the old text overline). Renders an
// official logo image when one is dropped at `src` (public/assets/images/psp/*), otherwise a brand-
// colored wordmark fallback. The Stripe / PaySimple / Authorize.Net marks are themselves wordmarks, so
// the fallback is a faithful stand-in until the real files are added — then just set `src` below.
import React from 'react';
import { Box, Typography } from '@mui/material';

const PROVIDERS = {
  stripe: { src: '/assets/images/stripe-logo.png', label: 'stripe', color: '#635BFF', transform: 'lowercase' },
  authnet: { src: '/assets/images/psp_authnet.png', label: 'Authorize.Net', color: '#1A4C8B', transform: 'none' },
  paysimple: { src: '/assets/images/psp_paysimple.png', label: 'PaySimple', color: '#0094C6', transform: 'none' },
  zelle: { src: '/assets/images/zelle-bank-logo.png', label: 'Zelle', color: '#6D1ED4', transform: 'none' },
};

// Logos come in very different aspect ratios (e.g. the Authorize.Net wordmark is ~7.6:1 vs ~2:1 for
// the others), so a fixed height alone makes some look huge. Constrain every logo to the SAME bounding
// box (maxHeight + maxWidth, object-fit contain) for a uniform footprint whatever the source image.
export default function ProviderLogo({ provider, height = 30, maxWidth = 132 }) {
  const p = PROVIDERS[provider];
  if (!p) return null;
  if (p.src) {
    return (
      <Box component="img" src={p.src} alt={p.label}
        sx={{ height: 'auto', width: 'auto', maxHeight: height, maxWidth, objectFit: 'contain', display: 'block', flexShrink: 0 }} />
    );
  }
  return (
    <Typography
      component="span"
      aria-label={p.label}
      sx={{
        fontWeight: 800, color: p.color, lineHeight: 1, whiteSpace: 'nowrap', flexShrink: 0,
        fontSize: `${Math.round(height * 0.72)}px`, textTransform: p.transform, letterSpacing: '-0.02em',
        fontFamily: '"Helvetica Neue", Arial, sans-serif',
      }}
    >
      {p.label}
    </Typography>
  );
}
